import React, {useEffect, useState} from "react";
import Navbar from "./Navbar";
import './profile.css';
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
function Profile() {
    const ID = Cookies.get("log_id");
    const [employee,setEmployeedetails] = useState({});
    const [otherdet,setOtherdetails] = useState({});
    const [image,setImage] = useState("");
    const navigate = useNavigate();
    const Toast = Swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                  },
                });
    function FetchProfiledetails() {
        axios.get(`${url.path}/fetch_profile_details/${ID}/`)
        .then((res) =>{
            if (res.data.status) {
                var emp = res.data.profile;
                var other = res.data.other;
                setEmployeedetails(emp);
                setOtherdetails(other);
                if (emp.profile) {
                    var img = `${url.path}/${emp.profile}`
                    setImage(img);
                }
            }
        })
        .catch((err) => {
            Toast.fire({
                icon:'error',
                title:err
              })
          });
    }
    useEffect(() =>{
        FetchProfiledetails();
    },[])
    function profile_edit() {
        navigate("/edit_profile");
    }
    return(
        <>
        <Navbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Profile</h1>
                </div>
                <center>
                    <h3 style={{fontSize:'25px'}}>{employee.Employee_Name}</h3>
                    {image ? (
                        <img src={image} alt="Profile" id="primg" />
                    ) : 
                    (
                        <img src="user8.jpeg" alt="Profile" id="primg"  />
                    )}
                    
                </center>
                <br />
                <form>
                    <h4>Personal Information</h4>
                    <div className="form-group-row mt-4">
                        <div className="form-group">
                            <label>Employee Name</label>
                            <input type="text" value={employee.Employee_Name} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Employee ID</label>
                            <input type="text" value={employee.Employee_ID} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="text" value={employee.Email} readOnly />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Username</label>
                            <input type="text" value={otherdet.username} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Contact</label>
                            <input type="text" value={employee.Contact_number} readOnly />
                        </div>
                        {employee.Department ? (
                            <div className="form-group">
                            <label>Department</label>
                            <input type="text" value={employee.Department} />
                            </div>
                        ) : null}
                        
                        
                    </div>
                    <div className="form-group-row">
                        {employee.Stream ? (
                            <div className="form-group">
                            <label>Stream</label>
                            <input type="text" value={employee.Stream} />
                        </div>
                        ) : null}
                        {employee.Date_Of_Joining ? (
                            <div className="form-group">
                            <label>Date Of Joining</label>
                            <input type="text" value={employee.Date_Of_Joining} />
                        </div>
                        ) : null}
                        
                        {employee.Qualification ? (
                            <div className="form-group">
                            <label>Qualification</label>
                            <input type="text" value={employee.Qualification} />
                        </div>
                        ) : null}
                    </div>
                    <div className="form-group-row">
                        {employee.Permanent_Address ? (
                            <div className="form-group">
                            <label>Permanent Address</label>
                            <input type="text" value={employee.Permanent_Address} />
                        </div>
                        ) : null}
                        {employee.Temporary_Address ? (
                            <div className="form-group">
                            <label>Temporary Address</label>
                            <input type="text" value={employee.Temporary_Address} />
                        </div>
                        ) : null}
                        {employee.Blood_Group ? (
                            <div className="form-group">
                            <label>Blood Group</label>
                            <input type="text" value={employee.Blood_Group} />
                        </div>
                        ) : null}
                        
                    </div>
                    <h4>Company Information</h4>
                    <div className="form-group-row mt-4">
                        <div className="form-group">
                            <label>Company Name</label>
                            <input type="text" value={otherdet.company_name} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Address</label>
                            <input type="text" value={otherdet.address}  readOnly />
                        </div>
                        <div className="form-group">
                            <label>Reg Number</label>
                            <input type="text" value={otherdet.Regno} readOnly />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Phone Number</label>
                            <input type="text" value={otherdet.mobile} readOnly />
                        </div>
                        <div className="form-group">
                            <label>GST Number</label>
                            <input type="text" value={otherdet.gstno} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="text" value={otherdet.mail} readOnly />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>SIN/SIS Number</label>
                            <input type="text" value={otherdet.sin_sis} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Industry Type</label>
                            <input type="text" value={otherdet.industry} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Website</label>
                            <input type="text" value={otherdet.website} readOnly />
                        </div>
                    </div>
                    
                </form>
                <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} onClick={profile_edit}>Edit Profile</button>
                        </div>
                    </center>
            </div>

        </div>
        </>
    );
}
export default Profile;